import { useEffect } from "react";
import { ArrowIcon } from "../components/ArrowIcon";
import "./ToolsPage.css";

const tools = [
  {
    slug: "contcam",
    name: "ContCam",
    description: "Your iPhone webcam for Windows and Linux, with direct pairing and desktop camera controls.",
  },
  {
    slug: "omawisper",
    name: "OmaWisper",
    description: "Voice dictation for Omarchy. Speak, transcribe, and paste into your focused app from a shortcut or the top bar.",
  },
] as const;

export function ToolsPage() {
  useEffect(() => {
    document.title = "Tools — Yash Bindal";

    let description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement("meta");
      description.setAttribute("name", "description");
      document.head.appendChild(description);
    }
    description.setAttribute(
      "content",
      "Small tools by Yash Bindal: ContCam, an iPhone webcam for Windows and Linux, and OmaWisper, voice dictation for your desktop.",
    );
  }, []);

  return (
    <main className="tools-page min-h-screen w-full px-6 pb-24 pt-20 sm:pt-28">
      <div className="mx-auto max-w-[var(--container-width)]">
        <nav aria-label="Breadcrumb" className="text-[13px]">
          <a
            href="/"
            className="inline-flex min-h-9 items-center gap-2 underline-offset-4 hover:underline"
            style={{ color: "rgb(var(--text-secondary))" }}
          >
            <ArrowIcon direction="left" /><span>Yash Bindal</span>
          </a>
        </nav>

        <header className="mt-10">
          <h1
            className="text-xl font-medium tracking-[-0.02em]"
            style={{ color: "rgb(var(--text-primary))" }}
          >
            Tools
          </h1>
          <p
            className="mt-3 text-sm leading-7"
            style={{ color: "rgb(var(--text-secondary))" }}
          >
            Small tools I build and use.
          </p>
        </header>

        <ul className="mt-10">
          {tools.map(tool => (
            <li
              key={tool.slug}
              className="border-b first:border-t"
              style={{ borderColor: "rgb(var(--border-color) / 0.5)" }}
            >
              <a
                href={`/tools/${tool.slug}`}
                className="group block py-6"
                aria-labelledby={`${tool.slug}-tool-title`}
                aria-describedby={`${tool.slug}-tool-description`}
              >
                <h2
                  id={`${tool.slug}-tool-title`}
                  className="flex items-center justify-between gap-6 text-[15px] font-medium"
                  style={{ color: "rgb(var(--text-primary))" }}
                >
                  <span className="underline-offset-4 group-hover:underline">{tool.name}</span>
                  <ArrowIcon />
                </h2>
                <p
                  id={`${tool.slug}-tool-description`}
                  className="mt-2 max-w-[47ch] text-[13px] leading-6"
                  style={{ color: "rgb(var(--text-secondary))" }}
                >
                  {tool.description}
                </p>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
}
